import { ReactComponent as AppStoreIcon } from 'components/icons/DownloadOnTheAppStoreBadgeUS-UKBlack.svg';
import { Link, useLocation } from 'react-router-dom';

export default function FooterDefault() {
  const location = useLocation();
  return (
    <footer className="p-8 lg:pl-segments-72px lg:pr-20 lg:pt-6 lg:pb-segments-72px bg-segments-footer-gray">
      <p className="text-black text-opacity-50">
        <span className="font-bold ">Segments </span>
        by Tresl
      </p>
      <div className="mt-12 lg:mt-3 lg:flex lg:flex-wrap lg:justify-between">
        <div className="leading-7 lg:grid lg:grid-cols-2 lg:space-x-14">
          <ul>
            <li>
              <ExternalLink href="https://tresl.co/about-us">
                About us
              </ExternalLink>
            </li>
            <li>
              <Link
                to={{
                  pathname: '/account/change-plan',
                  search: location.search,
                }}
                className="opacity-30"
              >
                Pricing
              </Link>
            </li>
            <li>
              <ExternalLink href="https://www.youtube.com/watch?v=Q8SoxWMKT_g&list=PLWwqp2K0ju4oKKfvwJyWKB66d79hIj9Dm">
                YouTube series
              </ExternalLink>
            </li>
            <li>
              <ExternalLink href="https://www.facebook.com/groups/ecomdatascience/">
                Facebook community
              </ExternalLink>
            </li>
          </ul>
          <ul>
            <li>
              <ExternalLink href="https://www.tresl.co/blog">
                Our blog
              </ExternalLink>
            </li>
            <li>
              <ExternalLink href="https://help.tresl.co/">
                Help &amp; FAQs
              </ExternalLink>
            </li>
            <li>
              <ExternalLink href="https://tresl.co/changelog">
                Changelog
              </ExternalLink>
            </li>
            <li>
              <ExternalLink href="https://feedback.tresl.co/">
                Public Roadmap
              </ExternalLink>
            </li>
          </ul>
        </div>

        <hr className="my-4 -mx-3 bg-segments-gray lg:hidden" />

        {/* Logo and status, ToS, privacy, and App Store links. At right on large screens, at bottom on small. */}
        <div className="flex justify-between lg:flex-col">
          <ul className="leading-7">
            <li className="lg:inline-block mr-7">
              <ExternalLink href="https://status.tresl.co/">
                System status
              </ExternalLink>
            </li>

            <li className="lg:inline-block mr-7">
              <ExternalLink href="https://tresl.co/terms">
                Terms of Service
              </ExternalLink>
            </li>

            <li className="lg:inline-block">
              <ExternalLink href="https://tresl.co/privacy-data">
                Privacy & Data
              </ExternalLink>
            </li>
          </ul>

          {/* App Store and Logo. Right-aligned row on large screens, vertically stacked on small. */}
          <div className="flex flex-col items-end justify-between lg:flex-row lg:pr-6">
            <a
              href="https://apps.apple.com/us/app/segments-by-tresl/id1548788981"
              target="_blank"
              rel="noreferrer"
            >
              <AppStoreIcon />
            </a>

            <img
              src="/assets/logo-tresl.png"
              alt="Logo Tresl"
              className="h-5 lg:h-9"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}

function ExternalLink({ href, children }: { href: string; children: string }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className="flex items-center space-x-1 opacity-30 group"
    >
      <span>{children}</span>
      <svg
        className="w-5 h-5 pb-0.5 opacity-0 group-hover:opacity-100"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 8.75V15.9375C15 16.1427 14.9596 16.3459 14.8811 16.5354C14.8025 16.725 14.6874 16.8973 14.5424 17.0424C14.3973 17.1874 14.225 17.3025 14.0354 17.3811C13.8459 17.4596 13.6427 17.5 13.4375 17.5H4.0625C3.6481 17.5 3.25067 17.3354 2.95765 17.0424C2.66462 16.7493 2.5 16.3519 2.5 15.9375V6.5625C2.5 6.1481 2.66462 5.75067 2.95765 5.45765C3.25067 5.16462 3.6481 5 4.0625 5H10.6047"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.125 2.5H17.5V6.875"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.75 11.25L17.1875 2.8125"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </a>
  );
}
